import { TestimonialCard } from './testimonial-card';

type TestimonialItem = {
  quote: string;
  name: string;
  title?: string;
  photoUrl?: string;
};

type Props = {
  items: TestimonialItem[];
};

export function TestimonialsSidebar({ items }: Props) {
  return (
    <div class="flex flex-col gap-6">
      {items.map((item, i) => (
        <TestimonialCard key={i} {...item} />
      ))}
    </div>
  );
}
